import { MdError } from "react-icons/md";
import {
  BiSolidMessageRoundedDots,
  BiSolidMessageRoundedError,
} from "react-icons/bi";
import {
  contractAbi,
  contractAddress,
  tokenAbi,
  tokenAddress,
} from "../../contracts";
import contAbi from "../../contracts/ContractAbi.json";
import {
  useReadContract,
  useWriteContract,
  useBalance,
  useChainId,
  useAccount,
} from "wagmi";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useWaitForTransactionReceipt } from "wagmi";
import Loader from "../Loader/Loader";
import { ConnectButton } from "@rainbow-me/rainbowkit";
const Registration = () => {
 
    
  //--------Set base API URL------
  const apiUrl = process.env.REACT_APP_API;
  //------- States-----------
  const [approveState, setApproveState] = useState(false);
  const [approveBUSD, setApproveBUSD] = useState(false);
  const [regfun, setregfun] = useState(true);
  const [balance, setbalance] = useState(false);
  const [one, setone] = useState("");
  const [ShowLoader, setShowLoader] = useState(true);
  // const { data: hash, writeContractAsync } = useWriteContract();
  const { writeContractAsync } = useWriteContract();
  const [referrerAddress, setreferrerAddress] = useState("");
  //----------
  const handleChange = async (event) => {
    const inputValue = event.target.value;
    setone(inputValue);
    validateField("one", inputValue);
  };
  const [hash, sethash] = useState("");
  const { data, error, isLoading } = useWaitForTransactionReceipt({ hash });
  // console.log("datadata",data?.status)
  //-----------
  const { address, isConnected, isDisconnected } = useAccount();
  const result = useReadContract({
    abi: contractAbi,
    address: contractAddress,
    functionName: "BASIC_PRICE",
  });

  //----------isUserExists
  const isUserExists = useReadContract({
    abi: contractAbi,
    address: contractAddress,
    args: [address],
    functionName: "isUserExists",
  });
  //--------balance check
  const bal = useBalance({
    address: address,
    token: tokenAddress,
  });

  //----------
  let color = "red";
  if (isConnected) {
    if (bal?.data?.value >= result?.data) {
      color = "green";
    } else {
      color = "red";
    }
  }
  const [secendHash, setsecendHash] = useState("");
  const chain = useChainId();
  //----Call Register Funtion---------
  const RegisterFun = async () => {
    try {
      const abc = await writeContractAsync({
        abi: contAbi,
        address: contractAddress,
        functionName: "registrationExt",
        args: [referrerAddress],
      });
      console.log("abc", abc);
      if (abc) {
        sethash(abc);
      }
    } catch (error) {
      setShowLoader(true);
      console.error("Error during contract call:", error.message || error);
    }
  };
  //------Call ApproveFuntion -------
  const approveFun = async () => {
    setShowLoader(false);
    if (isUserExists.data === false) {
      if (balance === true && approveBUSD === false) {
        abc();
        try {
          const app = await writeContractAsync({
            abi: tokenAbi,
            address: tokenAddress,
            functionName: "approve",
            args: [contractAddress, result.data],
          });
          console.log("app", app);
          if (app) {
            sethash(app);
          }
        } catch (error) {
          console.log(error);
      setShowLoader(true);
        }
      }
      //  else if (approveBUSD === true && regfun === true) {
      //   RegisterFun();
      // } else if (approveState === true && regfun === false) {
      //   register();
      // }
      else if (balanceSufficient === false) {
        toast("Insufficient balance", {
          position: "bottom-left",
          autoClose: 2000,
        });
      } else if(!one){
        toast("Upline is required!", {
          position: "bottom-left",
          autoClose: 2000,
        });
      }
    } else if (isConnected && balanceSufficient === true) {
      setShowLoader(true);
      toast("user already exists!", {
        position: "bottom-left",
        autoClose: 2000,
      });
    } else if (isConnected && balanceSufficient === false) {
      setShowLoader(true);
      toast("Insufficient balance!", {
        position: "bottom-left",
        autoClose: 2000,
      });
    } else if (isConnected && !one) {
      setShowLoader(true);
      toast("Upline is required!", {
        position: "bottom-left",
        autoClose: 2000,
      });
    }
    else if(!isConnected){
      setShowLoader(true);
      toast("Please Connect Wallet", {
        position: "bottom-left",
        autoClose: 2000,
      });
    }
  };
  //--------
  useEffect(() => {
    if (approveBUSD === true && data?.status === "success") {
      RegisterFun();
    } else if (approveState === true && regfun === false) {
      register();
    }
  }, [data]);
  //-----Check And Set Hash Base Conditions-----
  useEffect(() => {
    if (hash) {
      setApproveBUSD(true);
    }
    if (approveBUSD === true && hash) {
      setApproveState(true);
      setsecendHash(hash);
      setregfun(false);
    }
  }, [hash]);

  //-------balanceSufficient
  const balanceSufficient = bal.data?.value >= result.data;
  //-------Call Register API-----------
  const register = async () => {
    const data = {
      userAddress: address,
      referrer: one,
      txnHash: secendHash,
    };
    try {
      const response = await axios.post(`${apiUrl}/users/registration`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response) {
      }
      setShowLoader(true);
      console.log("Registration successful:", response);
      console.log("Registration successful:", response.data.result);
      toast(`${response.data.message}`, {
        position: "bottom-left",
        autoClose: 2000,
      });
    } catch (error) {
      setShowLoader(true);
      console.log("eee", error);
      toast(`${error.response.data.error}`, {
        position: "bottom-left",
        autoClose: 2000,
      });
    }
  };
  //-----------
  const [errors, setErrors] = useState("");
  const validateField = (name, value) => {
    let validationErrors = { ...errors };
    if (name === "one") {
      if (!value) {
        validationErrors.one = "Upline is required *";
      } else {
        delete validationErrors.one;
      }
    }
    setErrors(validationErrors);
  };

  //-----Apply Validation on Upline input-------
  const validateForm = () => {
    let valid = true;
    let validationErrors = {};
    if (one?.length === "") {
      validationErrors.one = "Upline is required *";
      valid = false;
    }
    setErrors(validationErrors);
    return valid;
  };

  //----------Get Referre Code API----------
  const abc = async () => {
    try {
      const response = await axios.get(`${apiUrl}/users/referrer/${one}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setreferrerAddress(response.data.referrerAddress);
    } catch (error) {
      console.log("error", error);
    }
  };

  //----------Get Code In URL----------
  // const searchParams = new URLSearchParams(window.location.search);
  // const userReferralCode = searchParams.get("userReferralCode");
  const pathname = window.location.pathname;
    const userReferralCode = pathname.split('=')[1];
  useEffect(() => {
    setone(userReferralCode);
  }, []);

  //---------
  useEffect(() => {
    if (balanceSufficient === true) {
      setbalance(true);
      validateForm();
    } else {
      setbalance(false);
      setApproveBUSD(false);
    }
    if (approveBUSD === false) {
      setApproveState(false);
    }
  }, [balanceSufficient]);

  return (
    <>
      <ToastContainer />
      <div className="w-full  min-h-screen py-24 mx-auto  Registration-container">
        <section className="text-gray-500 body-font container mx-auto">
          <div className="container px-5 py-24 mx-auto flex flex-wrap items-center">
            <div className="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0  ">
              <h1 className="title-font font-medium text-4xl py-3 mb-5 text-white ">
                Registration <br /> in Gain Apex USDT
              </h1>
              <div className="relative mb-4 flex flex-col w-full">
                <label
                  htmlFor="full-name"
                  className="leading-7 py-3 text-xl text-white"
                >
                  Your upline
                </label>
                {/* mt-3 md:w-1/2 lg:w-2/3 w-full bg-white rounded-lg focus:border-4 border-4 focus:border-blue-600 text-base outline-none text-gray-700 py-2 px-3 leading-8 transition-colors duration-200 ease-in-out  */}
                <input
                  type="text"
                  id="full-name"
                  name="referrer"
                  onChange={handleChange}
                  value={one}
                  className="
                   register-page-input"
                />
                {errors.one && <p style={{ color: "red" }}>{errors.one}</p>}
              </div>
              {isConnected ? (
                <p className="flex gap-5 items-center py-2 text-green-600 text-xl font-medium ">
                  <span>
                    <IoMdCheckmarkCircle size={25} />
                  </span>{" "}
                  Wallet: connected
                </p>
              ) : (
                <p className="flex gap-5 items-center py-2 text-red-600 text-xl font-medium ">
                  <span>
                    <MdError size={25} />
                  </span>{" "}
                  Wallet: not detected
                </p>
              )}
              <div className="md:block hidden lg:block">
                {chain === chain && isConnected ? (
                  <p className="flex items-center text-green-600 py-2 font-medium text-xl gap-5">
                    <span>
                      <IoMdCheckmarkCircle size={25} />
                    </span>{" "}
                    Network
                  </p>
                ) : (
                  <p className="flex items-center text-red-600 py-2 font-medium text-xl gap-5">
                    <span className=" rounded-full p-2 border-[2px] border-red-600 "></span>{" "}
                    Network
                  </p>
                )}
                {balanceSufficient ? (
                  <p className="flex items-center py-2 font-medium text-green-600 text-xl gap-5">
                    <span>
                      <IoMdCheckmarkCircle size={25} />
                    </span>
                    Balance
                  </p>
                ) : (
                  <p className="flex items-center text-red-600 py-2 font-medium text-xl gap-5">
                    <span className=" rounded-full p-2 border-[2px] border-red-600 "></span>{" "}
                    Balance
                  </p>
                )}
                {approveBUSD ? (
                  <p className="flex items-center py-2 font-medium text-green-600 text-xl gap-5">
                    <span>
                      <IoMdCheckmarkCircle size={25} />
                    </span>{" "}
                    Approve BUSD
                  </p>
                ) : (
                  <p className="flex items-center text-red-600 py-2 font-medium text-xl gap-5">
                    <span className=" rounded-full p-2 border-[2px] border-red-600 "></span>{" "}
                    Approve BUSD
                  </p>
                )}
                {approveState ? (
                  <p className="flex items-center py-2 text-green-600 font-medium text-xl gap-5">
                    <span>
                      <IoMdCheckmarkCircle size={25} />
                    </span>
                    Registration
                  </p>
                ) : (
                  <p className="flex items-center py-2 text-red-600 font-medium text-xl gap-5">
                    <span className=" rounded-full p-2 border-[2px] border-red-600 "></span>
                    Registration
                  </p>
                )}
              </div>
              <button
                onClick={approveFun}
                className=" hidden md:block lg:block w-1/4 font-bold mt-5  rounded-lg py-5 px-4  text-white registration-btn"
              >
                {/* Registration */}
                {ShowLoader ? "Registration" : <Loader />}
              </button>
              <p className="md:flex lg:flex hidden gap-3 items-center ml-6 py-2  font-medium ">
                Registration fee
                <span>
                  <BiSolidMessageRoundedError size={20} />
                </span>{" "}
              </p>
            </div>
            <div className="lg:w-2/5 md:w-2/2  rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 register-Information-main-contaner">
              <div className="flex gap-5 items-center text-2xl font-medium Information-div-register">
                <span>
                  <MdError size={25} />
                </span>{" "}
                Information
              </div>
              <p className="text-xl font-medium pt-4">Wallet not connected.</p>
              <p className="">
                Access the website via cryptowallet dapp browser (”Discover”
                button in Tokenpoket) or with Metamask extension installed.
              </p>
              <button className=" md:w-1/3 lg:w-1/3 w-full font-bold mt-5 hover:bg-red-500 md:rounded-[20px] lg:rounded-[20px] rounded-lg py-2 px-3  Read-guide text-white">
                Read guide
              </button>
              <iframe
                className="hidden md:block lg:block mt-5 w-full h-[200px] ifram-register"
                src="https://www.youtube.com/embed/0wL2kpuctmk?si=5fCKBRbZMck0aq_g"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/0wL2kpuctmk?si=5fCKBRbZMck0aq_g" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
              <p className="md:flex hidden lg:flex items-center gap-4 mt-8">
                <span>
                  <BiSolidMessageRoundedDots size={25} />
                </span>
                Need help with registration? Talk to experts in the support chat
              </p>
            </div>
            <div className=" block md:hidden lg:hidden mt-5">
              <p className="flex items-center py-2 font-medium text-xl gap-5">
                <span className=" rounded-full p-2 border-[2px] border-gray-600 "></span>{" "}
                Network
              </p>
              <p className="flex items-center py-2 font-medium text-xl gap-5">
                <span className=" rounded-full p-2 border-[2px] border-gray-600 "></span>{" "}
                Registration
              </p>
              <p className="flex items-center py-2 font-medium text-xl gap-5">
                <span className=" rounded-full p-2 border-[2px] border-gray-600 "></span>{" "}
                Balance
              </p>
              <p className="flex items-center py-2 font-medium text-xl gap-5">
                <span className=" rounded-full p-2 border-[2px] border-gray-600 "></span>{" "}
                Approve BUSD
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Registration;
